<template>
  <div class="wrapper d-flex flex-column">

    <GlobalLoader/>

    <nav class="row">
      <div class="col">
        <top-nav-bar
            :is-logged-in="isAuthenticated"
            :currentUser="currentUser || {}"/>
      </div>
    </nav>

    <main class="row flex-grow-1 mb-4">
      <div class="col">
        <router-view class="content-wrap"/>
      </div>
    </main>

    <footer class="row mt-auto">
      <div class="col">
        <footer-view
            :is-logged-in="isAuthenticated"
            :currentUser="currentUser"/>
      </div>
    </footer>
  </div>
</template>

<script>
import TopNavBar from "@/view/TopNavBar";
import {AccountActionTypeEnum} from "@/store/modules/account"
import {getSessionWithCrypto, sessionName} from "@/utils/Session"
import FooterView from "@/view/FooterView.vue";
import {AuthActionTypeEnum} from "@/store/modules/auth";
import {mapGetters} from "vuex";
import {toastError} from "@/utils/ToastUtil";
import GlobalLoader from "@/components/GlobalLoader.vue"

export default {
  name: 'App',
  data() {
    return {
      currentUser: null,
    }
  },
  components: {
    TopNavBar,
    FooterView,
    GlobalLoader
  },
  watch: {
    isLoggedIn: {
      immediate: true,
      handler(newVal) {
        if (newVal && !this.currentUser) {
          this.auth();
        } else if (!newVal) {
          this.currentUser = null;
        }
      }
    },
  },
  async mounted() {
    let credential = await getSessionWithCrypto(sessionName.CREDENTIAL)

    if (credential && credential.accessToken) {
      await this.auth();
    }
  },
  computed: {
    ...mapGetters({
      isLoggedIn: "isLoggedIn",
      isAuthenticated: "isAuthenticated",
      getCredentials: 'getCredentials'
    }),
  },
  methods: {
    async updToken(){
      let credential = await getSessionWithCrypto(sessionName.CREDENTIAL)
      try {
        await this.$store
            .dispatch(AuthActionTypeEnum.tokens, {
              "refreshToken":credential?credential.refreshToken:null,
              "accessToken":credential?credential.accessToken:null
            })
      } catch (error) {
        console.error(error)
        if (error.response?.status === 401 || error.response?.status === 403) {
          return;
        }
        toastError(error)
      }
    },
    async auth(){
      try {
        const response = await this.$store.dispatch(AccountActionTypeEnum.getCurrentUser);
        if (!!response && response.status === 200){
          this.currentUser = response.data.result;
        }
      } catch (error) {
        console.error('error: ', error)
        if (error.response?.status === 401 || error.response?.status === 403) {
          return;
        }
        toastError(error)
      }
    }
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.wrapper {
  display: flex;
  flex-direction: column;
}

.content-wrap {
  flex: 1 0 auto;
  padding-bottom: 1.5rem;
}
</style>